import type { FeatureHintStep } from 'components/shared/feature-hints';

const MARK_HINTS_STEPS: FeatureHintStep[] = [
  {
    id: 'chat-input',
    title: 'Ask. MARK answers.',
    body: "Type any enrollment question. MARK pulls from your institution's data, your goals, and peer cohort comparisons to return an answer in seconds.",
    placement: 'bottom',
    ringClassName: 'rounded-lg',
  },
  {
    id: 'quick-prompts',
    title: 'One click to your first answer',
    body: 'These three questions are ready to run. Each one pulls a real answer from your enrollment data. Pick one to get started, then ask your own.',
    placement: 'bottom',
    ringClassName: 'rounded-md ring-offset-2',
  },
  {
    id: 'new-chat',
    title: 'Start fresh. Stay focused.',
    body: "Each chat holds its own context. Start a new one when you're switching topics and MARK stays sharp on what you're actually asking.",
    placement: 'bottom-start',
  },
];

const MARK_TOKEN_USAGE_HINT_STEP: FeatureHintStep = {
  id: 'token-usage',
  title: 'Green means go.',
  body: 'You have plenty of questions left this month. Ask away.',
  placement: 'right-start',
  ringClassName: 'rounded-md ring-offset-8',
};

export const getMarkHintsSteps = (
  includeTokenUsageHint: boolean
): FeatureHintStep[] =>
  includeTokenUsageHint
    ? [...MARK_HINTS_STEPS, MARK_TOKEN_USAGE_HINT_STEP]
    : MARK_HINTS_STEPS;
